<template>
  <ul class="wealth-detail">
    <li v-for="item in wealthDetailData"
      :key="item.createTime">
      <div class="wealth-detail-list-title">{{ item.description }}</div>
      <div class="wealth-detail-list-date">{{ item.createTime | timestampToDate('YYYY-MM-DD') }}</div>
      <div class="wealth-detail-list-price"
        :class="{ 'gray': item.type !== 1 }">{{ item.type === 1 ? '+' : '-' }}{{ item.money }}元</div>
    </li>
  </ul>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import timestampToDate from '../filters/format-timestamp-to-date'

export default {
  name: 'WealthDetail',
  data () {
    return {
      pageNo: 1,
      loading: false,
      noMoreData: false // 没有数据不加载下一页
    }
  },
  computed: mapState({
    wealthDetailData: state => state.wealth.wealthDetailData
  }),
  filters: {
    timestampToDate
  },
  created () {
    this['wealth/resetWealthDetail']()
    this.callLoading()
  },
  mounted () {
    this.$el.addEventListener('scroll', this.throttle(() => {
      const scrollerHeight = this.$el.offsetHeight
      const { scrollTop, scrollHeight } = this.$el
      if (scrollerHeight + scrollTop >= scrollHeight) {
        this.callLoading()
      }
    }))
  },
  methods: {
    ...mapActions([
      'wealth/getWealthDetailData'
    ]),
    ...mapMutations([
      'wealth/resetWealthDetail'
    ]),
    throttle (action, interval = 500) {
      let timer

      return function () {
        clearTimeout(timer)
        timer = setTimeout(action, interval)
      }
    },
    callLoading () {
      if (!this.loading) {
        this.loading = !this.loading

        this.getList(this.pageNo)

        setTimeout(() => {
          this.loading = !this.loading
        }, 1000)
      }
    },
    getList (pageNo) {
      if (!this.noMoreData) {
        this['wealth/getWealthDetailData']({
          pageNo
        }).then(data => {
          if (!data.length) {
            this.noMoreData = true
          } else {
            this.pageNo++
          }
        })
      }
    }
  }
}
</script>

<style lang="scss">
  @charset 'utf-8';
  @import '../style/main';

  $global-width: 750;

  .wealth-detail {
    overflow-y: scroll;
    padding: 0 rem(30);
    height: 100%;
    line-height: 1.5;

    &:empty {
      &::before {
        content: '';
        display: block;
        margin: rem(260) auto 0;
        width: rem(312);
        height: rem(300);
        background-image: url('../assets/images/wealth-empty.png');
        background-size: contain;
      }
    }

    & > li {
      position: relative;
      padding: rem(30) 0;

      &::before {
        content: '';
        transform: scaleY(.5);
        transform-origin: 0 1px;
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 1px;
        background-color: #e4e4e4;
      }
    }

    &-list {
      &-title {
        max-width: rem(520);
        font-size: rem(30);
        color: #444;
      }

      &-date {
        max-width: rem(520);
        margin-top: rem(16);
        font-size: rem(24);
        color: #999;
      }

      &-price {
        position: absolute;
        top: rem(30);
        right: 0;
        font-weight: bold;
        font-size: rem(30);
        color: #f48e01;

        &.gray {
          color: #bfbfbf;
        }
      }
    }
  }

  $global-width: 720;
</style>
